import React from 'react';
import { SliderProps } from '@easyv/react-components';
import { ProInputSlider } from './ProInputSlider';

export interface ProInputEulerSliderProp extends Omit<SliderProps, 'onChange'> {
  name: string;
  value: number;
  showInput?: boolean;
  limitSliderOnly?: boolean;
  suffix?: string;
  prefix?: string;
  className?: string;
  precisionOnShow?: number;
  precisionOnSave?: number;
  onChange?: (name: string, value: number) => void;
  onBlur: (name: string, value: number) => void;
}

export function ProInputEulerSlider(props: ProInputEulerSliderProp) {
  const realToInputValue = React.useCallback((value: number) => {
    return (value / Math.PI) * 180;
  }, []);

  const inputToRealValue = React.useCallback((value: number) => {
    return (value * Math.PI) / 180;
  }, []);

  return (
    <ProInputSlider
      {...props}
      realToInputValue={realToInputValue}
      inputToRealValue={inputToRealValue}
    />
  );
}
